import {NavLink, useParams} from 'react-router-dom';

import {
    Box,
    Breadcrumbs,
} from '@mantine/core';
import {Step} from '../types';

export const EditPageNavigation = ({component}: { component: Step }) => {

    const {id: playbookIdParam, phaseId: phaseIdParam} = useParams();
    const playbookId = playbookIdParam ?? component.playbookId;
    const phaseId = phaseIdParam ?? component.phaseId;

    const breadcrumbs = [{
        title: 'Home',
        href: '/dashboard',
    }, {
        title: 'Playbooks',
        href: '/playbooks',
    }, {
        title: 'Playbook',
        href: playbookId ? `/playbooks/${playbookId}` : undefined,
    }, {
        title: component.phase?.displayName || component.phase?.name || 'Phase',
        href: playbookId && phaseId ? `/playbooks/${playbookId}/phases/${phaseId}` : undefined,
    }, {
        title: component.displayName || component.name,
    }].map((item, index) => (
        <Box key={index}> {
            item
                .href ?
                <NavLink to={item.href}>{item.title}</NavLink> : item.title
        }
        </Box>
    ));

    return (
        <Box p={'xs'}><Breadcrumbs separator='→' mt='xs'>{breadcrumbs}</Breadcrumbs></Box>
    );
};
